export default [{
    label: 'ORDER',
    name: 'orderId',
    width: '',
    exportwidth: '20',
    sortable: true
  },
  {
    label: 'FROM ACC',
    name: 'fromTradeAccountNumber',
    width: '',
    exportwidth: '20',
    sortable: true
  },
  {
    label: 'TO ACC',
    name: 'toTradeAccountNumber',
    width: '',
    exportwidth: '20',
    sortable: true
  },
  {
    label: 'TIME',
    name: 'createdDate',
    exportwidth: '20',
    width: '',
    sortable: true
  },
  {
    label: 'AMOUNT',
    name: 'amount',
    exportwidth: '20',
    width: '',
    sortable: true
  },
  {
    label: 'AMOUNT',
    name: 'realAmount',
    width: '',
    exportwidth: '20',
    sortable: true,
    isshow: 'completed'
  },
  {
    label: 'status',
    name: 'status',
    width: '',
    exportwidth: '20',
    sortable: true
  },
  {
    label: 'COMMENT',
    name: 'remark',
    exportwidth: '20',
    width: '',
    sortable: true
  }
]
